import { api } from '../Api';

export class TipoEmissaoService {

    getTipoEmissao() {
        return api.get('/tipo-emissao-nf').then(res=> res.data.body)
    }
}